import {get, post } from './http';

//购买记录
export const getShoppingRecord = (params) => get("/order/v1/order/list", params);